import { createReducer, on } from '@ngrx/store';
import { LoadingState } from 'app/utils/callstate';

import { CompanyActions } from '../actions';
import { CompanyState } from '../company.types';

export const initialCompanyState: CompanyState = {
    company: null,
    callState: LoadingState.Init,
};

export const reducer = createReducer(
    initialCompanyState,
    on(
        CompanyActions.companyRequested,
        state => ({ ...state, callState: LoadingState.Loading })
    ),
    on(
        CompanyActions.companyLoaded,
        (state, { company }) => ({ ...state, company, callState: LoadingState.Loaded })
    ),
    on(
        CompanyActions.companyCancelled,
        (state, { errorMessage }) => ({ ...state, callState: { errorMessage } })
    ),
    // on(
    //     CompanyActions.companyDeleteRequested,
    //     state => ({ ...state, callState: LoadingState.Loading })
    // ),
    // on(
    //     CompanyActions.companyDeleteError,
    //     (state, { errorMessage }) => ({ ...state, callState: { errorMessage } })
    // ),
    // on(
    //     CompanyActions.companyDeleteSuccess,
    //     (state, { entry }) => ({ ...state, entry, callState: LoadingState.Loaded })
    // ),
);



